// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2Yc30","approved":"Status_approved__r7wkk","rejected":"Status_rejected__1AfIO","expired":"Status_expired__usUnO","label":"Status_label__2oW0-"};